import React, { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [phase, setPhase] = useState(0); // boot animation

  // Boot animation on mount
  React.useEffect(() => {
    const t = [setTimeout(() => setPhase(1), 300), setTimeout(() => setPhase(2), 800), setTimeout(() => setPhase(3), 1200)];
    return () => t.forEach(clearTimeout);
  }, []);

  const doLogin = async (user, pass) => {
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: user, password: pass }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'ACCESS DENIED'); setLoading(false); return; }
      // Store role for guest banner detection
      if (data.role) localStorage.setItem('auth_role', data.role);
      else localStorage.removeItem('auth_role');
      onLogin(data.token, data.username);
    } catch { setError('CONNECTION FAILED'); }
    setLoading(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) { setError('CREDENTIALS REQUIRED'); return; }
    await doLogin(username.trim(), password.trim());
  };

  const handleGuestLogin = () => {
    setUsername('guest');
    setPassword('guest123');
    doLogin('guest', 'guest123');
  };

  return (
    <div className="login-page">
      <div className="login-bg-grid" />
      <div className="login-bg-vignette" />

      <div className="login-container">
        {/* Arc reactor */}
        <div className="login-reactor">
          <div className="login-reactor-core" />
          <svg className="login-reactor-ring" viewBox="0 0 60 60"><circle cx="30" cy="30" r="24" /></svg>
          <svg className="login-reactor-ring2" viewBox="0 0 60 60"><circle cx="30" cy="30" r="18" /></svg>
        </div>

        {/* Boot sequence text */}
        <div className="login-boot">
          {phase >= 1 && <div className="login-boot-line">MASHRUR INDUSTRIES — COMMAND CENTER</div>}
          {phase >= 2 && <div className="login-boot-line">F.R.I.D.A.Y. NEURAL INTERFACE v3.7.2</div>}
          {phase >= 3 && <div className="login-boot-line login-boot-auth">AUTHENTICATION REQUIRED</div>}
        </div>

        {/* Login form */}
        {phase >= 3 && (
          <form className="login-form" onSubmit={handleLogin}>
            <div className="login-field">
              <label className="login-label" htmlFor="login-username">OPERATOR ID</label>
              <input id="login-username" className="login-input" type="text" value={username} onChange={e => setUsername(e.target.value)}
                placeholder="Enter username" autoFocus autoComplete="username" />
            </div>
            <div className="login-field">
              <label className="login-label" htmlFor="login-password">ACCESS KEY</label>
              <input id="login-password" className="login-input" type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Enter password" autoComplete="current-password" />
            </div>

            {error && <div className="login-error" role="alert">{error}</div>}

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? (
                <span className="login-btn-loading">
                  <span /><span /><span />
                  AUTHENTICATING...
                </span>
              ) : 'INITIALIZE'}
            </button>

            <button className="login-btn login-btn-guest" type="button" disabled={loading} onClick={handleGuestLogin}>
              👤 TRY AS GUEST
            </button>
          </form>
        )}

        <div className="login-footer">SECURE ACCESS PROTOCOL — ENCRYPTED</div>
      </div>
    </div>
  );
}

export default Login;
